import { IconProps } from '@/components/Icon';

export const IconCross = ({ width = 10, height = 10, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 10 10' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M1.00483 1.00501C1.2782 0.731646 1.72141 0.731646 1.99478 1.00501L4.9998 4.01004L8.00483 1.00501C8.2782 0.731646 8.72141 0.731646 8.99478 1.00501C9.26815 1.27838 9.26815 1.7216 8.99478 1.99496L5.98975 4.99999L8.99478 8.00501C9.26815 8.27838 9.26815 8.7216 8.99478 8.99496C8.72141 9.26833 8.2782 9.26833 8.00483 8.99496L4.9998 5.98994L1.99478 8.99496C1.72141 9.26833 1.2782 9.26833 1.00483 8.99496C0.731463 8.7216 0.731463 8.27838 1.00483 8.00501L4.00986 4.99999L1.00483 1.99496C0.731463 1.7216 0.731463 1.27838 1.00483 1.00501Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  );
};
